module.exports = __webpack_public_path__ + "img/node_level2.44dad495.png";